import { horizontal, onlyRight, onlyTop, vertical } from '../themeUtils';
export const TRIOLIET_COLORS = {
    accent: {
        lightest: '#ffcbd1',
        light: '#f89696',
        main: '#e00b25',
        dark: '#d3001c',
        darkest: '#c5000c',
    },
    brand: {
        lightest: '#bed59d',
        light: '#afc59f',
        main: '#90b178',
        dark: '#64943c',
        darkest: '#5c8639',
    },
    primary: {
        lightest: '#bed59d',
        light: '#afc59f',
        main: '#90b178',
        dark: '#64943c',
        darkest: '#5c8639',
    },
    success: {
        light: '#8df960',
        main: '#46bc01',
        dark: '#469d01',
    },
    error: {
        lightest: '#fcdad9',
        light: '#ff6953',
        main: '#f44336',
        dark: '#e50601',
    },
    warning: {
        lightest: '#fee4c9',
        light: '#ffc62f',
        main: '#f1a019',
    },
    grey: {
        lightest: '#E6E6E6',
        light: '#CCCCCC',
        default: '#666666',
        dark: '#4D4D4D',
        darkest: '#333333',
    },
    background: {
        body: '#F0F0F0',
        light: '#F7F7F7',
        dark: '#D0D0D0',
    },
    font: {
        light: '#FFFFFF',
        dark: '#000000',
    },
    common: {
        contentHover: '#eaf1e7',
    },
};
export const TRIOLIET_FONTS = {
    family: "'helvetica-neue', Arial, Helvetica, sans-serif",
    size: {
        small: 10,
        mediumSmall: 12,
        medium: 14,
        mediumBig: 16,
        big: 18,
        caption: 12,
        title: 22,
        heading: 35,
    },
    lineHeight: {
        small: 1,
        mediumSmall: 1.1,
        medium: 1.2,
        mediumBig: 1.67,
        big: 1.8,
    },
    weight: {
        light: 300,
        normal: 400,
        bold: 700,
    },
};
export const TRIOLIET_BORDER_RADIUS = {
    low: 2,
    default: 5,
    high: 100,
    onlyTop: onlyTop(5),
    onlyRight: onlyRight(5),
};
export const TRIOLIET_BOX_SHADOW = {
    light: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
    default: '0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
    dark: '0 0 0 1px #fff, 0 0 2px 4px #666',
};
export const TRIOLIET_SPACING = {
    margin: {
        smallest: 5,
        small: 10,
        default: 20,
        large: 30,
        largest: 50,
        horizontalDefault: horizontal(20),
        verticalDefault: vertical(20),
    },
    padding: {
        smallest: 5,
        small: 10,
        default: 20,
        large: 30,
        largest: 50,
        horizontalDefault: horizontal(20),
        verticalDefault: vertical(20),
    },
    layout: {
        fullWidth: 1440,
        partialWidth: 1024,
    },
};
export const TRIOLIET_LAYOUT = {
    width: {
        full: 1440,
        partial: 920,
    },
    sidebar: {
        full: 320,
    },
    header: {
        topBar: 60,
        menu: 50,
    },
};
//# sourceMappingURL=triolietThemeConf.js.map